import * as React from 'react';
import { IMenuItem } from '../../types/IMenuItem';
import { NavItem, NavLink } from 'reactstrap';
import { If } from '../If';
import { Link } from 'react-router-dom';
import { IEnableModulesConfigurationParametersItem } from '../../../redux/types/IEnableModulesConfigurationParameterItem';
import { MEMBERS_PORTAL } from '../../../accounts/Consts';
import { PAGE_ANCHOR_MY_CASES } from '../../../membersportal/Consts';
import { handlePageAnchorNavigation, setPageAnchorTarget } from '../../../util/tools';

interface IFormBoxMenuProps {
    menuItems: IMenuItem[];
    setCurrentPage: (link: string) => void;
    enableModules?: IEnableModulesConfigurationParametersItem[];
    currentUserNameNumber?: string;
    portalType?: string;
    getUserCRMIPNumber: (guid: string) => void;
}

export class FormBoxMenu extends React.Component<IFormBoxMenuProps>{
    constructor(props: IFormBoxMenuProps) {
        super(props);
    }

    renderMenuItem(item: IMenuItem, currentNameNumber:string): JSX.Element {

        const { enableModules, portalType } = this.props;

        let filteredItem: IMenuItem = item;
        if (enableModules && enableModules.length > 0) {
            const disableModules = enableModules.filter(x => !x.enable);
            if (disableModules && disableModules.length > 0) {
                if (filteredItem.children.length > 0) {
                    filteredItem.children = item.children.filter(function (current) {
                        if (disableModules.findIndex(x => x.link === current.link) === -1)
                            return current;
                    });
                }
            }
        }

        let menuItem = null;

        if (filteredItem.children.length > 0) {
            menuItem = <div key={filteredItem.link} className={["form-group col-lg-4 col-md-6 col-sm-6", !filteredItem.isEnabled && "disabledItem"].join(" ")}>
                <div className="formBox">
                    <div className="heading">
                        <span className={filteredItem.icon} aria-hidden="true"></span>
                        <span className="title">{filteredItem.label}</span>
                    </div>

                    <If condition={filteredItem.children && filteredItem.children.length > 0}>
                        <ul>
                            {
                                filteredItem.children.map((c: IMenuItem, i: number) => {
                                    const isMyAccountTile = (filteredItem.name && filteredItem.name === 'myAccount');
                                    const approved = portalType !== MEMBERS_PORTAL || (currentNameNumber && currentNameNumber !== '00000');
                                    const childEnabled = c.isEnabled && (approved || isMyAccountTile);

                                    return childEnabled ? (
                                        <NavItem key={i}>
                                            {c.link && (c.link.startsWith('http://') || c.link.startsWith('https://')) ? (
                                                <a href={c.link} target="_blank" rel="noopener noreferrer">
                                                    {c.label}
                                                </a>
                                            ) : (
                                                <NavLink
                                                    tag={Link}
                                                    to={c.name === 'openNewCase' ? { pathname: "/cases/openNewCase", aboutProps: { type: "new" } } : c.link}
                                                    onClick={(e) => {
                                                        if (c.name === 'myCases' || c.name === 'cases') {
                                                            e.preventDefault();

                                                            setPageAnchorTarget({
                                                                path: '/',
                                                                anchor: PAGE_ANCHOR_MY_CASES
                                                            });

                                                            handlePageAnchorNavigation();
                                                            return;
                                                        }

                                                        this.props.setCurrentPage(c.link);
                                                    }}
                                                >
                                                    {c.label}
                                                </NavLink>
                                            )}
                                        </NavItem>
                                    ) : (
                                        <li className="disabledItem" key={i}>{c.label}</li>
                                    );
                                })
                            }
                        </ul>
                    </If>
                </div>
            </div>
        }

        return menuItem;
    }

    renderMenuItems(): JSX.Element[] {
        const { menuItems } = this.props;

        if (menuItems && menuItems.length > 0) {
            let filteredMenuItems = JSON.parse(JSON.stringify(menuItems));
            filteredMenuItems = filteredMenuItems.filter(m => m.link !== '/' && m.link !== null);
            return filteredMenuItems.map((i: IMenuItem) => this.renderMenuItem(i, this.props.currentUserNameNumber));
        }
        else {
            return null;
        }
    }

    render() {
        const {portalType} = this.props;
        let className = portalType === MEMBERS_PORTAL ? " cardsList flexWrapRow " : " row cardsList "
        return (
            <div className={className}>
                {this.renderMenuItems()}
            </div>);
    }
}